/**
 * MUI Grid components.
 * See: https://material-ui.com/components/grid/
 */

import { Grid, GridProps } from '@mui/material';
import { styled } from '@mui/system';

export const Container = styled((other: GridProps) => <Grid container={true} {...other} />)``;

export const Item = styled((other: GridProps) => <Grid item={true} {...other} />)``;
